import { useContext, useEffect, useState } from "react";
import { setCurrentScreen } from "firebase/analytics";
import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import {
  InnerWrapper,
  MainContainer,
  TitleAndActionBox,
} from "../../common";
import { UBButton } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { AccountList } from "../../container/Account";
import { useAllAccountsList } from "../../../hooks/useAccount/accountsList";
import {
  getCustomerByBusinessID,
  getSupplierByBusinessID,
} from "../../../database/helpers/customer";
import withObservables from "@nozbe/with-observables";
import { useFiltersHandler } from "../../../hooks/useFilterHandler";
import NonIdealNew from "../../common/NonIdealNew";
import { PlayIcon } from "../../../assets/icons/icon";

const Account = ({ customers, suppliers }) => {
  const navigate = useNavigate();
  const [I18n] = useContext(LanguageContext);
  const [pageSize, setPageSize] = useState(0);

  const location = useLocation();

  const {
    filters,
    appliedChips,
    handleFilterChange,
    resetFilters,
    handleRemoveChip,
    isAppliedFilter,
    isAppliedFilterOtherThenKeywords,
    isResetFilter,
    setIsResetFilter,
  } = useFiltersHandler(location?.state, I18n);

  const {
    accountList,
    handleAccountList,
    totalTake,
    totalGiven,
    totalCount,
    isLoading: accountListLoading,
  } = useAllAccountsList();

  useEffect(() => {
    setCurrentScreen(analytics, "acc_discovered");
    triggerLogEvent(analytics, "acc_discovered", {});
  }, []);

  const handleAddContact = () => {
    const hasDiscovered = localStorage.getItem("hasDiscoveredAccount");

    if (!hasDiscovered) {
      triggerLogEvent(analytics, "acc_discovered", { source: "accounts_page" });
      localStorage.setItem("hasDiscoveredAccount", "true");
    } else {
      triggerLogEvent(analytics, "acc_add_contact", {
        source: "accounts_page",
      });
    }
    navigate("/Accounts/ContactForm", {
      state: { isSupplier: filters?.customers == "Suppliers" },
    });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key.toLowerCase() === "n" && event.shiftKey) {
        event.preventDefault();
        handleAddContact();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleAddContact]);

  let isNonIdeal = customers?.length === 0 && suppliers?.length === 0;

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox data={{ title: I18n.accounts }}>
            {filters?.customers == "By others" ? null : (
              <UBButton
                onClick={handleAddContact}
                id="addContactButton"
                className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
                title={I18n.add_contact}
              />
            )}
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.start_your_account_by_adding_contact}
                subtitle={I18n.account_help_you_track}
                button1Title="add_contact"
                // button2Title="watch_video"
                onButton1Click={handleAddContact}
                loading={false}
                disabledOne={false}
                disabledTwo={false}
                buttonOneId={"add_contact"}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                video_footer={{
                  title: I18n.add_contact,
                  onClick: handleAddContact,
                }}
                videoTitle={I18n.start_your_account_by_adding_contact}
                videoSubtitle={I18n.account_help_you_track}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
              />
            ) : (
              <AccountList
                navigate={navigate}
                accountList={accountList}
                handleAccountList={handleAccountList}
                totalCount={totalCount}
                totalTake={totalTake}
                totalGiven={totalGiven}
                pageSize={pageSize}
                setPageSize={setPageSize}
                customers={customers}
                suppliers={suppliers}
                isLoading={accountListLoading}
                filters={filters}
                appliedChips={appliedChips}
                handleFilterChange={handleFilterChange}
                resetFilters={resetFilters}
                isAppliedFilterOtherThenKeywords={
                  isAppliedFilterOtherThenKeywords
                }
                isResetFilter={isResetFilter}
                setIsResetFilter={setIsResetFilter}
                handleRemoveChip={handleRemoveChip}
                isAppliedFilter={isAppliedFilter}
              />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables(["customers", "allBusinesses"], () => ({
  customers: getCustomerByBusinessID(localStorage.getItem("business_id")),
  suppliers: getSupplierByBusinessID(localStorage.getItem("business_id")),
}));

export default enhance(Account);
